import {TextInput, TextInputHidden, SquareButton, ForwardsBackwardsBar, HeaderBig, LoadButton, Loading, HeaderWithButton} from '../common/Common';
import {useContext, useEffect, useRef, useState} from 'react';
import './ConfirmMail.css';
import { LocaleContext, LoginContext, StateContext } from '../common/App';
import { postWithCsrf } from '../common/util';
import { LoadState } from '../common/enums.mjs';
import { useAutoLoad, useNavigateSmart } from '../common/hooks';

export function ConfirmMail(props) {
    const locale = useContext(LocaleContext);
    const state = useContext(StateContext);
    const login = useContext(LoginContext);

    const navigate = useNavigateSmart();

    const [resendText, setResendText] = useState("");
    const [resendTextClass, setResendTextClass] = useState("");

    const [nextMailSCount, setNextMailSCount] = useState(0);
    const nextMailTimeoutRef = useRef();

    const [sendState, setSendState] = useState(LoadState.NONE);

    function resendMail() {
        try {
            postWithCsrf("/user/resend_confirmation_mail", {}, state).then(response => {
                if(response.ok) {
                    return response.json();
                }
                
                throw new Error("Response code: " + response.status);
            }).then(json => {
                setResendText(locale.msgs.RESEND_MAIL_SUCCESS);
                setResendTextClass("text_success");
                setSendState(LoadState.LOAD_SUCCESS);

                calcNextMailSCount(json.date);
            }).catch(error => {
                console.log("ERROR: " + error);
                setResendText(locale.msgs.RESEND_MAIL_ERROR);
                setResendTextClass("text_error");
                setSendState(LoadState.LOAD_ERROR);
            });

            // Calling setLoadState() after postWithCsrf() as it could throw an exception
            setSendState(LoadState.LOADING);
        }
        catch(e) {
            console.log(e);
        }
    }

    function calcNextMailSCount(lastMailSentDate) {
        if(nextMailTimeoutRef.current) {
            clearTimeout(nextMailTimeoutRef.current);
        }

        const lastMailSentMs = new Date(lastMailSentDate).getTime();
        const nowMs = new Date().getTime();
        
        const elapsedMs = nowMs - lastMailSentMs;
        const elapsedS = Math.round(elapsedMs / 1000);

        const sToWait = 60 - elapsedS;

        setNextMailSCount(sToWait);
        
        if(sToWait <= 0) {
            setSendState(LoadState.NONE);
            setResendText("");
        }
        else {
            nextMailTimeoutRef.current = setTimeout(() => calcNextMailSCount(lastMailSentDate), 1000);
        }
    }


    // EFFECTS:

    /*
    useEffect(() => {
        const eventSource = new EventSource("/user/is_mail_confirmed_sse");
  
        eventSource.onmessage = function(event) {
            // const data = JSON.parse(event.data);
            // console.log("Got message: " + data.message);
            
            login.setMailConfirmed(true);
            navigate("/mail_confirmed/?username=" + login.username);
        };

        eventSource.onerror = function(error) {
            console.error("EventSource failed:", error);
            eventSource.close();
        };
    }, []);
    */

    const [loadState, setLoadState] = useAutoLoad((json) => {
        // On load success

        if(json.last_confirmation_mail_send_date !== "") {
            calcNextMailSCount(json.last_confirmation_mail_send_date);
        }

        if(json.email_confirmed) {
            login.setMailConfirmed(true);
            navigate("/mail_confirmed/?username=" + login.username);
        }

    }, () => {
        // On load error
    }, () => {
        // On before load

        return "/user/get_confirm_mail_info";
    }, [], true, false, false, false, true);


    // RENDER:
    
    return (
        loadState !== LoadState.LOAD_SUCCESS ?
            <div className="margin_top_high">
                <Loading fixed={true} />
            </div>
        :
            <div className="confirm_mail_box">
                <HeaderWithButton noBtn={true} langSelection={true} />

                <div className="margin_to_header"></div>

                <div className="confirm_mail_content side_padding">
                    <div className="head" id="thank_you_head">{locale.msgs.THANKS_FOR_REGISTRATION}</div>
                    <div className="text" id="thank_you_text">{locale.msgs.LOOKUP_MAIL_BOX}</div>

                    <div className="head" id="no_mail_received_head">{locale.msgs.NO_MAIL_RECEIVED}</div>
                    <div className="text" id="no_mail_received_text">{locale.msgs.RESEND_MAIL_DESCR}</div>

                    <div id="resend_mail">
                        <LoadButton text={locale.msgs.RESEND_MAIL}
                                clickable={nextMailSCount <= 0}
                                onClick={() => resendMail()}
                                saving={sendState === LoadState.LOADING}
                                notSaved={false}
                                errText={""} />
                    </div>

                    {resendText != "" ? <div id="resend_text" className={resendTextClass}>{resendText}</div> : "" }

                    { nextMailSCount > 0 ?
                        <div className="text confirm_mail_counter_text">{locale.msgs.PLEASE_WAIT_S_UNTIL_RESEND_MAIL.replace("${{seconds}}", nextMailSCount)}</div>
                    :
                        null
                    }
                    
                </div>
            </div>
    );
}
